import React, { FC } from 'react';
import { observer } from 'mobx-react';
import PollVotesList from '../shared/poll-votes-list';
import PollEntity from '../../../store/polls-store/poll-entity';
import ResponseEntity from '../../../store/polls-store/response-entity';
import FullScreenButton from '../shared/full-screen-button';
import { FullScreenButtonContent } from '../../../constans/polls-constants';
import PollStatus from '../shared/poll-status/poll-status';

interface IProps {
  poll: PollEntity;
  getPollChoisesList: (pollId: string) => Promise<ResponseEntity[] | void>;
  closeFullScreenMode: () => void;
}

const PollFullScreenContainer: FC<IProps> = ({ poll, getPollChoisesList, closeFullScreenMode }) => {
  return (
    <div className='poll-full-screen-container'>
      <div className='poll-full-screen-header'>
        <FullScreenButton buttonStateContent={FullScreenButtonContent.EXIT} actionHandler={closeFullScreenMode}/>
      </div>
      <div className='poll-full-screen-content-container'>
        <div className='poll-full-screen-content-container-header'>
          <PollStatus status={poll.status}/>
          <div className='poll-full-screen-content-value'>{poll.value}</div>
        </div>
        <PollVotesList
          responses={poll.getFilteredResponses()}
          getPollChoisesList={getPollChoisesList}
          selectedPollId={poll.getId()}
          shouldHideVotesCount
        />
      </div>
    </div>
  );
};

export default observer(PollFullScreenContainer);
